import InsightsNumberWidget from './InsightsNumberWidget'

export default InsightsNumberWidget
